var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('time',{staticClass:"display-date",attrs:{"datetime":_vm.date.toISOString()}},[_c('span',[_vm._v(_vm._s(_vm.dateLabel))]),(_vm.showTime)?_c('small',[_vm._v(_vm._s(_vm.timeLabel))]):_vm._e()]):_c('span',{staticClass:"text-muted"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }